import React, { Component } from 'react';
import { Container, Button, Card, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import '../App.css';

/**
 * ActivationCopy Component
 *
 * Landing page for activation emails
 * Shows the activation token with a "Click to Copy" button
 * Provides clear instructions to paste into the Dijitto app
 */

function ActivationCopyWrapper() {
  const { token } = useParams();
  return <ActivationCopy token={token} />;
}

class ActivationCopy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      token: props.token || ''
    };
  }

  handleCopyToken = () => {
    const { token } = this.state;

    // Copy to clipboard
    navigator.clipboard.writeText(token).then(() => {
      this.setState({ copied: true });

      // Reset "copied" state after 3 seconds
      setTimeout(() => {
        this.setState({ copied: false });
      }, 3000);
    }).catch((err) => {
      console.error('Failed to copy:', err);
      alert('Failed to copy. Please select and copy the code manually.');
    });
  };

  render() {
    const { token, copied } = this.state;

    return (
      <Container fluid className="App" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', paddingTop: '40px' }}>
        <Container style={{ maxWidth: '600px' }}>
          <Card style={{ boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <Card.Body style={{ padding: '40px' }}>
              {/* Header */}
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h1 style={{ color: '#1E3A8A', fontSize: '32px', fontWeight: '700', marginBottom: '10px' }}>
                  🎉 Welcome to Dijitto!
                </h1>
                <p style={{ color: '#666', fontSize: '16px' }}>
                  Your store has been approved and is ready to activate
                </p>
              </div>

              {/* Instructions */}
              <Alert variant="info" style={{ backgroundColor: '#e3f2fd', borderColor: '#2196F3', borderLeft: '4px solid #2196F3' }}>
                <Alert.Heading style={{ fontSize: '18px', marginBottom: '10px' }}>
                  📱 How to Activate Your Account
                </Alert.Heading>
                <ol style={{ marginBottom: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
                  <li><strong>Copy your activation code</strong> using the button below</li>
                  <li><strong>Open the Dijitto app</strong> on your device</li>
                  <li><strong>Paste the code</strong> into the activation field</li>
                </ol>
              </Alert>

              {/* Important Notice */}
              <Alert variant="warning" style={{ backgroundColor: '#fff3cd', borderColor: '#ffc107', marginTop: '20px' }}>
                <p style={{ marginBottom: 0, fontSize: '14px' }}>
                  <strong>⚠️ Important:</strong> This activation code only works when pasted into the Dijitto app.
                  Make sure you have the app installed on your device.
                </p>
              </Alert>

              {/* Activation Code */}
              <div style={{ marginTop: '30px', marginBottom: '30px' }}>
                <p style={{ fontWeight: '600', marginBottom: '10px', fontSize: '16px' }}>
                  Your Activation Code:
                </p>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '2px solid #dee2e6',
                  wordBreak: 'break-all',
                  fontFamily: 'monospace',
                  fontSize: '14px',
                  color: '#333',
                  marginBottom: '20px'
                }}>
                  {token}
                </div>

                {/* Copy Button */}
                <Button
                  variant={copied ? 'success' : 'primary'}
                  size="lg"
                  onClick={this.handleCopyToken}
                  style={{
                    width: '100%',
                    padding: '15px',
                    fontSize: '18px',
                    fontWeight: '600',
                    borderRadius: '8px'
                  }}
                >
                  {copied ? '✅ Copied to Clipboard!' : '📋 Click to Copy Activation Code'}
                </Button>
              </div>

              {/* What's Next */}
              <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h5 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '15px' }}>
                  What happens next?
                </h5>
                <ul style={{ marginBottom: 0, paddingLeft: '20px', lineHeight: '1.8', fontSize: '14px' }}>
                  <li>Create a secure password for your store</li>
                  <li>Set up your crypto wallets (BTC, LTC, DOGE)</li>
                  <li>Configure your payment settings</li>
                  <li>Start accepting cryptocurrency payments</li>
                </ul>
              </div>

              {/* Support */}
              <div style={{ marginTop: '30px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                <p style={{ marginBottom: '5px' }}>Need help?</p>
                <p style={{ marginBottom: 0 }}>
                  Contact us at <a href="mailto:support@dijitto.io" style={{ color: '#2196F3' }}>support@dijitto.io</a>
                </p>
              </div>
            </Card.Body>
          </Card>

          {/* Footer */}
          <div style={{ textAlign: 'center', marginTop: '30px', marginBottom: '30px', color: '#999', fontSize: '12px' }}>
            <p>Powered by Dijitto - Cryptocurrency Payment Solutions</p>
          </div>
        </Container>
      </Container>
    );
  }
}

export default ActivationCopyWrapper;
